import React from "react";
import { Layout, MintingHistory } from "../components";

const MintingHistoryPage = () => {
  return (
    <>
      <Layout>
        <MintingHistory />
      </Layout>
    </>
  );
};

export default MintingHistoryPage;
